import React, {FC, useEffect, useState} from 'react'
import { UserTable } from './components/UserTable';
import axios from 'axios'
import { Auth } from 'aws-amplify';

const API_URL_API = process.env.REACT_APP_API_URL_BACKEND
export const GET_ALL_USER_URL = `${API_URL_API}/admin/user`


const UserList: FC = () => {

  const [loading, SetLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);


  useEffect(() => {
    getAllUser()
  },[])


  const getAllUser = async () => {
    
    try {

      const auth = await Auth.currentSession();
      const token = auth.getAccessToken().getJwtToken();

      const {data: result} = await axios.get(GET_ALL_USER_URL,{
        headers : {
          Authorization: `Bearer ${token}`
        }
      });
        setUsers(result.data.users);
        setRoles(result.data.roles);
        
        SetLoading(false);
    } catch (err) {
      console.log(err)
    }     
  };

    return (
        <>
        {
          loading ? (
            <div className='d-flex flex-center'>
              <span className="spinner-grow text-dark mx-2"></span>
              <span className="spinner-grow text-dark mx-2"></span>
              <span className="spinner-grow text-dark mx-2"></span>
              <span className="spinner-grow text-dark mx-2"></span>
            </div>
          ) : (
               <UserTable users={users} roles={roles} getAllUser={getAllUser} className='mb-5 mb-xl-8' /> 
          )
        }

          
        </>
  )
}

export {UserList}
